
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAssociatedTargetAisFilled as ObiAssociatedTargetAisFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-associated-target-ais-filled.js';
 
 
 

 
 export const ObiAssociatedTargetAisFilled = createComponent({
   react: React,
   tagName: 'obi-associated-target-ais-filled',
   elementClass: ObiAssociatedTargetAisFilledElement,
   events: {
     
   }
  });
 
 